module.exports = __webpack_public_path__ + "img/Vermont outline.a40fca61.png";